/**
 * Legacy photo lists of the measurement cards (top-level fields of the project), shown and granted
 * by the block project-measurement-report-data. Must match `PROJECT_MEASUREMENT_REPORT_PHOTO_FIELDS`
 * in apps/apolloserver (services/projectBlocks.ts).
 */
export const PROJECT_MEASUREMENT_REPORT_PHOTO_FIELDS = [
  'bricksPlasteredAttachments',
  'cardboardPoppetAttachments',
  'pedimentAttachments',
  'pitchedRoofOptionalAttachments',
  'rafterVisibleAttachments',
  'rafterOptionalAttachments',
  'outerRoofOptionalAttachments',
  'bricksFrontAttachments',
  'bricksBackAttachments',
  'bricksOptionalAttachments',
  'roofSidesAttachments',
  'roofSidesShadowsAttachments',
  'roofSidesSketchAttachments',
  'roofSidesOptionalAttachments',
  'roofAccessAttachments',
  'roofAccessOptionalAttachments',
  'hakAndZsSameRoomAttachments',
  'hakAttachments',
  'hakOptionalAttachments',
  'zsWithCoverAttachments',
  'zsWithoutCoverAttachments',
  'zsOptionalAttachments',
  'mainElectricMeterAttachments',
  'seconaryElectricMeterAttachments',
  'electricMeterOptionalAttachments',
  'acInstallationLocationAttachments',
  'locationAndCablePathOptionalAttachments',
  'equipotentialBusBarPresentAttachments',
  'earthingPresentAttachments',
  'earthingOptionalAttachments',
  'internetConnectionAttachments',
  'heavyCurrentPresentAttachments',
  'wallboxLocationAttachments',
  'wallboxOptionalAttachments',
  'flatRoofSurfaceAttachments',
  'flatRoofOptionalAttachments',
];
